import * as React from "react";

import {formatMoney2} from "@Common/ui-components/language/format-money";

import "./instant-change-content.scss";

export const InstantChangeContent = ({modalContent, activeSubscription, selectedDetails, ccInfo}) => (
    <div className="instant-change-content instant-change-content-uc6m">
        <div className="content-container">
            <div className="new-plan-section">
                <div className="new-plan-cost">
                    {formatMoney2(selectedDetails.pricePoint.priceCents / 100)}
                </div>
                <div className="new-plan-type">
                    XD+ {selectedDetails.plan.typeLabel}
                </div>
                <div className="new-plan-description">
                    Gain access to even MORE premium content + other special features yet to be identified
                </div>
            </div>
            <div className="apply-coupon-section">
                <div className="apply-coupon">
                    Apply coupon
                </div>
            </div>
            <div className="change-details-section">
                <ul className="list">
                    <li className="list-item">
                        <span className="bullet"></span>
                        <div className="plan-description">XD+ {selectedDetails.plan.typeLabel} - Prorated Charges</div>
                        <div className="cost">{formatMoney2(selectedDetails.firstInvoice.totalCents / 100)}</div>
                    </li>
                </ul>
                {selectedDetails.firstInvoice.creditsAppliedCents > 0 && (<>
                    <div className="credits-applied">
                        Credits Applied
                    </div>
                    <ul className="list">
                        <li className="list-item">
                            <span className="bullet"></span>
                            <div className="plan-description">{activeSubscription.label} {activeSubscription.planType} - Prorated Credits for
                            </div>
                            <div className="credits-applied">{formatMoney2(selectedDetails.firstInvoice.creditsAppliedCents / 100)}</div>
                        </li>
                    <div className="prorated-dates">{new Date().toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' })} - {new Date(activeSubscription.dateNextRenewal.date).toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' })}</div>
                    </ul>
                </>)}
                <hr className="divider"></hr>
                <div className="total-cost">{formatMoney2(selectedDetails.firstInvoice.dueCents / 100)}</div>
            </div>
            <div className="total-cost-description-section">
                <div className="total-cost-description">
                    You will be charged {formatMoney2(selectedDetails.firstInvoice.dueCents / 100)} for prorated charges via {ccInfo.value?.type.toUpperCase()} ending in {ccInfo.value?.last4} today
                </div>
            </div>
            <div className="next-billing-date-section">
                <div className="next-billing-date">
                    NEXT BILLING DATE: {new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit'
                    })}
                    <br />
                    <br />
                    AMOUNT: {formatMoney2(selectedDetails.pricePoint.priceCents / 100)}
                </div>
            </div>
            <div className="update-subscription-section">
                <button 
                    className="update-subscription"
                    onClick={() => modalContent.onChange('review')}
                >
                    Update Subscription   <span className="arrow">&#8594;</span>
                </button>
            </div>
        </div>
    </div>
)